import { combineReducers } from "@reduxjs/toolkit";
import drugManagementSlice from "./drugManagementSlice";

export default combineReducers({
  drugManagement: drugManagementSlice,
});
